import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const FETCH_PARTIES_REQUEST = 'app/ConversationRedirectPage/FETCH_PARTIES_REQUEST';
export const FETCH_PARTIES_SUCCESS = 'app/ConversationRedirectPage/FETCH_PARTIES_SUCCESS';
export const FETCH_PARTIES_ERROR = 'app/ConversationRedirectPage/FETCH_PARTIES_ERROR';

// ================ Reducer ================ //

const initialState = {
  transactionId: null,
  customerId: null,
  providerId: null,
  fetchInProgress: false,
  notFound: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PARTIES_REQUEST:
      return { ...initialState, transactionId: payload.id, fetchInProgress: true };
    case FETCH_PARTIES_SUCCESS:
      return {
        ...state,
        fetchInProgress: false,
        customerId: payload.customerId,
        providerId: payload.providerId,
      };
    case FETCH_PARTIES_ERROR:
      // A bad id, a transaction that isn't ours, and a network failure all end
      // the same way on screen. Keeping them indistinguishable is deliberate:
      // the page must not reveal whether a conversation exists.
      return { ...state, fetchInProgress: false, notFound: true };
    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchPartiesRequest = id => ({ type: FETCH_PARTIES_REQUEST, payload: { id } });
const fetchPartiesSuccess = parties => ({ type: FETCH_PARTIES_SUCCESS, payload: parties });
const fetchPartiesError = e => ({ type: FETCH_PARTIES_ERROR, payload: e, error: true });

/** The two party ids of a transaction, from the same relationships TransactionPage reads. */
export const partiesOf = response => ({
  customerId: response?.data?.data?.relationships?.customer?.data?.id?.uuid || null,
  providerId: response?.data?.data?.relationships?.provider?.data?.id?.uuid || null,
});

// ================ Thunks ================ //

export const loadData = params => (dispatch, getState, sdk) => {
  const id = params?.id;
  dispatch(fetchPartiesRequest(id));

  return sdk.transactions
    .show({ id, include: ['customer', 'provider'] })
    .then(response => dispatch(fetchPartiesSuccess(partiesOf(response))))
    .catch(e => dispatch(fetchPartiesError(storableError(e))));
};
